var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.informations.img)?_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"d-block",attrs:{"loading":"lazy","src":_vm.files + _vm.informations.img,"alt":_vm.informations.name,"height":_vm.height}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }